import React from "react";
import logo from "../../assest/logo.png";
import "./nav.css";
import { Link } from "react-router-dom";
import more from "../../assest/more_icon.svg";
import { Drawer } from "@mui/material";
import { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';

const NavBar = () => {
  const [open, setOpen] = useState(false);
  const open_drawer = () => {
    setOpen(true);
  };
  const close_drawer = () => {
    setOpen(false);
  };
  return (
    <div className="main_navbar">
      <img src={logo} alt="logo" className="logo" />
      <div className="nav_url">
        <p>
          <Link
            to="/contact"
            style={{ textDecoration: "none", color: "#111827" }}
          >
            Contact
          </Link>
        </p>

        <button className="download_btn">
          <a
            href="https://firebasestorage.googleapis.com/v0/b/modern-portfolio-6ac9c.appspot.com/o/DebabrataResume(Updated).pdf?alt=media&token=3ee9cddc-a989-4ee4-b6eb-61f3b92d2eac"
            target="_blank"
            rel="noreferrer"
          >
            Download CV
          </a>
        </button>
      </div>
      <img
        src={more}
        alt=""
        className="mobile_view__icon"
        onClick={open_drawer}
      />
      <Drawer anchor={"right"} open={open} onClose={close_drawer}>
        <div className="mobile_header_view">
          <div className="drawer_header">
            <Link to="/" className="drawer_NavLinks">
              Home
            </Link>

            <Link to="/contact" className="drawer_NavLinks">
              Contact
            </Link>
          </div>
          <CloseIcon onClick={close_drawer} />
        </div>
      </Drawer>
    </div>
  );
};

export default NavBar;
